module.exports = __webpack_public_path__ + "static/MuseoSans-300-dc947f791d9ba143ef8a196d60d3d40b.woff2";